import { jsx } from 'react/jsx-runtime';
import { useContext, createContext } from 'react';

const StepperDialogContext = /*#__PURE__*/createContext({
  registerProceed: () => {},
  setPrimaryDisabled: () => {},
  showToast: () => {}
});
const StepIndexContext = /*#__PURE__*/createContext(undefined);
const StepperDialogStepsContext = /*#__PURE__*/createContext({
  setSteps: () => {}
});
function StepIndexProvider(_ref) {
  let {
    index,
    children
  } = _ref;
  return jsx(StepIndexContext.Provider, {
    value: index,
    children: children
  });
}
function useStepperDialog() {
  const context = useContext(StepperDialogContext);
  const index = useContext(StepIndexContext);
  return Object.assign(Object.assign({}, context), {
    index
  });
}
function useStepperDialogSteps() {
  return useContext(StepperDialogStepsContext);
}

export { StepIndexContext, StepIndexProvider, StepperDialogContext, StepperDialogStepsContext, useStepperDialog, useStepperDialogSteps };
